/**
 * Calculate age from a date-of-birth string (YYYY-MM-DD).
 * Returns null if dob is falsy.
 */
export const calcAge = (dob) => {
    if (!dob) return null;
    const today = new Date();
    const birth = new Date(dob);
    let age = today.getFullYear() - birth.getFullYear();
    const m = today.getMonth() - birth.getMonth();
    if (m < 0 || (m === 0 && today.getDate() < birth.getDate())) age--;
    return age > 0 ? age : null;
};

/**
 * Format height from decimal feet (e.g. 5.5) to a display string (e.g. "5'6\"").
 * Returns null if height is falsy.
 */
export const formatHeight = (decimalFeet) => {
    if (!decimalFeet) return null;
    const feet = Math.floor(decimalFeet);
    const inches = Math.round((decimalFeet - feet) * 12);
    return `${feet}'${inches}"`;
};
